import { cn } from '../../lib/utils';

/**
 * Infinite horizontal scroller.
 *
 * `items` is rendered twice so the track can loop seamlessly at -50%. The
 * duplicate is hidden from assistive tech, and the strip pauses on hover /
 * focus (WCAG 2.2.2) and freezes entirely under prefers-reduced-motion.
 */
export default function Marquee({
  items,
  renderItem,
  duration = 40,
  reverse = false,
  gap = 'gap-5',
  className,
  ...props
}) {
  return (
    <div
      className={cn('marquee', reverse && 'marquee-reverse', className)}
      style={{ '--marquee-duration': `${duration}s` }}
      {...props}
    >
      <div className={cn('marquee-track', gap)}>
        {items.map((item, index) => (
          <div key={`a-${index}`} className="shrink-0">
            {renderItem(item, index)}
          </div>
        ))}
        {items.map((item, index) => (
          <div key={`b-${index}`} className="shrink-0" aria-hidden="true">
            {renderItem(item, index)}
          </div>
        ))}
      </div>
    </div>
  );
}
